import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { ILoadableComponentRef } from './interfaces/iloadable-component-ref.interface';
import { ILoadableComponent } from './interfaces/iloadable-component.interface';

@Injectable()
export class ComponentLoaderService {
	private _containers: { [key: string]: ViewContainerRef } = {};

	addContainer(key: string, containerRef: ViewContainerRef): void {
		this._containers[key] = containerRef;
	}

	getContainer(key: string): ViewContainerRef {
		return this._containers[key];
	}

	load(component: Type<ILoadableComponent>, componentContainer: ViewContainerRef): ILoadableComponentRef {
		componentContainer.clear();
		const componentRef: ComponentRef<ILoadableComponent> = componentContainer.createComponent(component);

		return {
			container: componentContainer,
			componentRef: componentRef,
			instanceRef: <T>() => <T>componentRef.instance
		};
	}

	unload(loadableComponentRef: ILoadableComponentRef): void {
		if (loadableComponentRef.container) {
			loadableComponentRef.container.clear();
		}

		if (loadableComponentRef.componentRef) {
			loadableComponentRef.componentRef.destroy();
		}
	}
}
